import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class ArrangementsEndpointsService {
  readonly #service = inject(ServicesService);

  public arrangements() {
    return this.#service.vesta('arrangement');
  }
}
